import * as Icons from 'lucide-react';
import { type LucideIcon } from 'lucide-react';
import { FadeIn, Stagger, StaggerItem } from '@/components/motion/FadeIn';
import { MaskReveal } from '@/components/motion/Reveal';

interface Industry {
  icon: string;
  name: string;
  outcome: string;
}

interface Props {
  items: Industry[];
}

export function HomeIndustries({ items }: Props) {
  if (!items || items.length === 0) return null;
  return (
    <MaskReveal className="section-y-lg" tilt={-0.8} duration={1.1}>
      <div className="container-wide">
        <FadeIn>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-500">Industries</p>
          <h2 className="mt-3 text-h2 text-fg">Built for ambitious teams across sectors.</h2>
        </FadeIn>
        <Stagger className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((ind) => {
            const IconName = (ind.icon ?? 'Briefcase') as keyof typeof Icons;
            const Icon = (Icons[IconName] ?? Icons.Briefcase) as LucideIcon;
            return (
              <StaggerItem key={ind.name}>
                <div className="group relative rounded-xl border border-border bg-bg-elevated/40 p-6 transition-all hover:-translate-y-0.5 hover:border-gold-500/40 hover:shadow-gold">
                  <div className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-bg-subtle text-gold-500">
                    <Icon className="h-5 w-5" />
                  </div>
                  <h3 className="mt-4 text-lg font-semibold tracking-tight">{ind.name}</h3>
                  <p className="mt-2 text-sm text-fg-muted">{ind.outcome}</p>
                  <span className="absolute inset-x-6 -bottom-px h-px origin-left scale-x-0 bg-gradient-to-r from-gold-500/0 via-gold-500 to-gold-500/0 transition-transform duration-slow group-hover:scale-x-100" />
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </div>
    </MaskReveal>
  );
}